import styled, { css } from 'styled-components';

import {
  scale005,
  xdlColorA11yBorderOnLight,
  xdlColorCardInspire01,
  xdlColorCardInspire02,
  xdlColorCardInspire03,
  xdlColorCardInspire04,
  xdlColorCardInspire05,
  xdlColorCardInspire06,
  xdlColorCardInspire07,
  xdlColorTextOnLight,
} from '@xing-com/tokens';

import { Card } from '..';

import type { CardInspireVariants } from './card-inspire.types';

type CardInspireTProps = {
  $variant: CardInspireVariants;
};

// *** Variants ***
export const variants = {
  1: css`
    background-color: ${xdlColorCardInspire01} !important;
  `,
  2: css`
    background-color: ${xdlColorCardInspire02} !important;
  `,
  3: css`
    background-color: ${xdlColorCardInspire03} !important;
  `,
  4: css`
    background-color: ${xdlColorCardInspire04} !important;
  `,
  5: css`
    background-color: ${xdlColorCardInspire05} !important;
  `,
  6: css`
    background-color: ${xdlColorCardInspire06} !important;
  `,
  7: css`
    background-color: ${xdlColorCardInspire07} !important;
  `,
};

// *** Components ***
export const CardContainer = styled.div`
  // FIXME: Move helmet styles here after upgrading to Next-Yak
`;

export const CardInspire = styled(Card)<CardInspireTProps>`
  && {
    border-color: ${xdlColorA11yBorderOnLight};
    border-width: ${scale005};
    color: ${xdlColorTextOnLight};
  }

  ${(props) => css`
    ${props.$variant && variants[props.$variant]};
  `};
`;
